export default "__VITE_ASSET__CmiUV76n__"